import { ImagePath } from "../../../../assets/ImagePath";
import { Globe, BarChart3, PlusCircle, Users, Clock, Archive, Phone } from "lucide-react";


export const menuItems = [
  {
    name: "Home",
    icon: ImagePath.HomeLogo,
  },
  {
    name: "App Marketplace",
    icon: ImagePath.MarketplaceLogo,
    hasSubmenu: true,
    slug: "app_marketplace",
    submenu: [
      { name: "Dashboard", icon: BarChart3 },
      { name: "Overview", icon: Globe },
      { name: "Quick Actions", icon: PlusCircle },
    ],
  },
  {
    name: "Contacts",
    icon: ImagePath.ContactLogo,
    hasSubmenu: true,
    submenu: [
      { name: "All Contacts", icon: Users },
      { name: "Recent", icon: Clock },
      { name: "Groups", icon: Archive },
      { name: "Emergency", icon: Phone },
    ],
  },
  {
    name: "Messages",
    icon: ImagePath.messageLogo,
  },
  //   {
  //   name: "Favourites",
  //   icon: ImagePath.FavoriteLogo,
  //   hasSubmenu: true,
  //   // submenu: [
  //   //   { name: "Maritime Healthcare", icon: Stethoscope },
  //   //   { name: "onship AI Assistant", icon: Bot },
  //   //   { name: "Shipping Infostream", icon: Radio },
  //   // ],
  // },
];